import React, { ReactNode } from 'react'

import { ReactComponent as BriefcaseIcon } from '@app/assets/Small/Outline/Briefcase.svg'
import { ReactComponent as KeyIcon } from '@app/assets/Small/Outline/Key.svg'
import { useIntl } from '@app/intl/Intl'
import { PillBadge } from '@app/lib/display/PillBadge/PillBadge'
import { Message } from '@app/queries/CustomerAsLawyer/models'

export const prepareMessageBadges = (message: Message): ReactNode | undefined => {
  const { formatMessage } = useIntl()
  if (!message.case?.insuranceClaim) {
    return undefined
  }

  const insuranceClaim = message.case?.insuranceClaim

  if (!insuranceClaim?.insuredPropertyType && !insuranceClaim?.insuredPropertyAffiliation) {
    return undefined
  }

  return (
    <>
      {insuranceClaim?.insuredPropertyType && (
        <PillBadge size={'sm'} icon={<BriefcaseIcon />}>
          {formatMessage({
            id: `Badges.InsuredPropertyType.${insuranceClaim.insuredPropertyType}`
          })}
        </PillBadge>
      )}
      {insuranceClaim?.insuredPropertyAffiliation && (
        <PillBadge size={'sm'} icon={<KeyIcon />}>
          {formatMessage({
            id: `Badges.InsuredPropertyAffiliation.${insuranceClaim.insuredPropertyAffiliation}`
          })}
        </PillBadge>
      )}
    </>
  )
}
